export default {
	total: 2421,
	data: [
		{
			id: 1,
			image_url: '\/mt\/Eh\/',
			title: 'Homemade Sex Tape Featuring Our Steamy Sex On Bed',
			href: 'http:\/\/upornia.com\/videos\/homemade-sex-tape-featuring-our-steamy-sex-on-bed\/?source=0',
			data_href: 'http:\/\/upornia.com\/videos\/homemade-sex-tape-featuring-our-steamy-sex-on-bed\/',
			thumb_id: 446844
		},
		{
			id: 2,
			image_url: '\/mt\/Fc\/',
			title: 'Private Cam',
			href: 'http:\/\/upornia.com\/videos\/private-cam\/?source=0',
			data_href: 'http:\/\/upornia.com\/videos\/private-cam\/',
			thumb_id: 187809
		},
		{
			id: 3,
			image_url: '\/mt\/bk\/',
			title: 'Girl 10..lord Have Lenience',
			href: 'http:\/\/upornia.com\/videos\/girl-10-lord-have-lenience\/?source=0',
			data_href: 'http:\/\/upornia.com\/videos\/girl-10-lord-have-lenience\/',
			thumb_id: 573167
		}
	]
};



// WEBPACK FOOTER //
// ./src/desktop/scripts/searchPageComponents/testData.js